import { render, staticRenderFns } from "./VehicleOwnersWidget.vue?vue&type=template&id=17523e50&scoped=true&"
import script from "./VehicleOwnersWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleOwnersWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOwnersWidget.vue?vue&type=style&index=0&id=17523e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17523e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17523e50')) {
      api.createRecord('17523e50', component.options)
    } else {
      api.reload('17523e50', component.options)
    }
    module.hot.accept("./VehicleOwnersWidget.vue?vue&type=template&id=17523e50&scoped=true&", function () {
      api.rerender('17523e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleOwnersWidget.vue"
export default component.exports